<template>
  <Card
    :class="{
      error:
        showValidation &&
        categorizeErrors.some((error) => error.type === 'affecteds' && error.passed === false),
    }"
    class="borderShadow shadow-3"
    tabindex="0"
    test-id="cardPeople"
  >
    <template #title>
      <div
        class="title flex justify-content-between flex-wrap cursor-pointer"
        @click="ManageActions('create')"
        @keydown.enter="ManageActions('create')"
        @keydown.space.prevent="ManageActions('create')"
        tabindex="0"
        role="button"
      >
        <div test-id="cardPeopleTitle" class="text-gray-700 font-medium text-xl">
          {{ viewData.cardDenunciante.title }}
        </div>
        <!-- <Button icon="pi pi-plus"  class="p-button-rounded p-button-info p-button-outlined" @click="$router.push({path: '/actuaciones/' + actuacionType + '/initial-data/denunciante?id=', query: {id: 'new'}})" test-id="cardPeoplePlusIcon"/> -->
        <Button
          icon="pi pi-plus"
          class="p-button-rounded p-button-info p-button-outlined text-gray-500"
          :disabled="disabled"
          @click="ManageActions('create')"
          test-id="AfectadosAddButton"
        />
      </div>
    </template>
    <template #content>
      <div class="search1">
        <div
          v-for="(item, i) in denunciantes"
          :key="i"
          class="grid justify-content-between align-items-center"
        >
          <!-- action pegar en relato -->
          <Button
            icon="pi pi-clone"
            style="color: rgba(104, 159, 56, 1)"
            class="p-button-rounded p-button-info p-button-text text-xl col-1"
            @click="pasteInDeposition(item)"
            test-id="cardPeoplePencil"
            v-if="!editMode"
          />

          <!-- Nombre, dni, tag y domicilio -->
          <div
            class="col-10 flex-row"
            test-id="ordenPublico"
            v-if="item.doc?.condicion?.nombre !== 'A Determinar'"
          >
            <div class="flex justify-content-start align-items-center gap-3">
              <p class="title">
                <span :test-id="'elemento-denunciante' + i" class="text-black-alpha-80">
                  {{ nombreYapellidos(item) }}
                </span>
              </p>
              <p>DNI: {{ item.doc.documento }}</p>
              <Tag
                :severity="colorTag(item.doc?.condicion?.nombre)"
                :class="colorTag(item.doc?.condicion?.nombre)"
                :value="item.doc?.condicion?.nombre"
                rounded
                test-id="tagProtagonista"
                v-if="colorTag(item.doc?.condicion?.nombre) !== ''"
              />
            </div>
            <p class="address" v-if="!item.ordenPublico">
              {{ item.doc.domicilio || item.doc.domicilioSIPE }}
            </p>
          </div>
          <div v-else><span class="block mb-2">A Determinar</span></div>

          <!-- actions enviar y borrar -->
          <div class="col-1">
            <MenuOptions
              :item="item"
              :deleteItem="(event) => ManageActions('delete', item, event)"
              :editItem="() => ManageActions('edit', item)"
            />
          </div>
        </div>
        <div v-if="denunciantes.length < 1" class="flex justify-content-end">
          <span class="text-gray-500">
            <p :style="{ color: showValidation ? '#dc3545' : '' }">Sin Registros</p>
          </span>
        </div>

        <!-- ERRORES -->
        <!-- <div
            v-if="
              alertas() != 'ok' && viewData.showPeoplesAlertas && showValidation == true
            "
            style="color: #dc3545"
            class="text-right"
          >
            {{ alertas() }}
          </div> -->

        <div
          v-if="warningAlerts() !== 'ok' && viewData.showPeoplesAlertas && showValidation"
          style="color: #ffc107"
          class="text-right"
        >
          {{ warningAlerts() }}
        </div>
      </div>
    </template>
  </Card>
  <!-- </div> -->
</template>

<script setup>
import { computed, ref, toRefs, watch } from "vue";
import { useRouterCompat } from "../composables/useRouterCompat";
import { useStoreCompat } from "../composables/useStoreCompat";
import MenuOptions from "./MenuOptions/MenuOptions.vue";

const props = defineProps({
  datos: {
    type: [Array, Object],
    default: () => [],
  },
  formType: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array,
    default: () => [],
  },
  warning: {
    type: Array,
    default: () => [],
  },
  showValidation: {
    type: Boolean,
    default: false,
  },
  deleteConfirmationInProgress: {
    type: Boolean,
    default: false,
  },
  modalVisble: {
    type: Boolean,
    default: false,
  },
  viewData: {
    type: Object,
    default: () => ({
      cardDenunciante: {},
      formDenunciaDeleteButton: {},
    }),
  },
  actuacionType: {
    type: String,
    default: "",
  },
  categorizeErrors: {
    type: Array,
    default: () => [],
  },
  editMode: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "navigateToDenunciante",
  "disableAfectation",
  "updateValue",
  "deleteConfirmationPeoples",
  "moveToDeposition",
]);

const {
  datos,
  disabled,
  errors,
  warning,
  showValidation,
  deleteConfirmationInProgress,
  modalVisble,
  viewData,
  actuacionType,
  categorizeErrors,
  editMode,
} = toRefs(props);

const store = useStoreCompat();
const { router } = useRouterCompat();

const isSearching = ref(false);
const people = ref({});
const dni = ref(null);
const error = ref(false);
const sexo = ref(null);
const filteredSexo = ref([]);
const timer = ref(true);
const showDeleteButton = ref(false);

watch(
  datos,
  (newDatos) => {
    people.value = newDatos || {};
    if (newDatos?.documento) dni.value = newDatos.documento;
    if (newDatos?.sexo) sexo.value = newDatos.sexo;
  },
  { immediate: true }
);

const sexoList = computed(() => store.state.siis?.sexo || []);
const denunciantes = computed(() => store.getters["sumario/denunciante/denuncianteTodos"] || []);

const dniPeople = computed({
  get() {
    return dni.value;
  },
  set(value) {
    error.value = false;
    isSearching.value = false;
    dni.value = value;
  },
});

const dataSexo = computed({
  get() {
    return sexo.value;
  },
  set(value) {
    sexo.value = value;
  },
});

const emitNavigateEvent = () => {
  emit("navigateToDenunciante", { id: "new" });
};

const deleteConfirmation = (arrId, event) => {
  emit(
    "deleteConfirmationPeoples",
    event,
    viewData.value.formDenunciaDeleteButton?.whistleblowerText,
    arrId
  );
};

const ManageActions = (action, item, event) => {
  const currentAction = action || "";

  if (currentAction === "create") {
    emitNavigateEvent();
    emit("disableAfectation");
  } else if (currentAction === "edit") {
    router.push({
      path: `/actuaciones/new/${actuacionType.value}/initial/denunciante`,
      query: { id: item.arrId },
    });
    emit("disableAfectation");
  } else if (currentAction === "delete") {
    emit("disableAfectation");
    deleteConfirmation(item.doc.arrId, event);
  }
};

// Esta funcion se hizo para que no aparescan undefined en la lista de Denunciantes
const nombreYapellidos = (item) => {
  let NombreCompleto = "Datos Incompletos";
  if (item.ordenPublico === true) {
    NombreCompleto = "Orden público";
    return NombreCompleto;
  }

  NombreCompleto =
    item.doc.apellido !== undefined ? item.doc.apellido.toUpperCase() : NombreCompleto;
  if (NombreCompleto === "Datos Incompletos") {
    NombreCompleto = item.doc.nombre !== undefined ? item.doc.nombre : NombreCompleto;
  } else {
    NombreCompleto =
      item.doc.nombre !== undefined ? `${NombreCompleto}, ${item.doc.nombre}` : NombreCompleto;
  }
  return NombreCompleto;
};

/* eslint-disable no-else-return */
const alertas = () => {
  const denuncianteTitle = viewData.value.cardDenunciante?.title || "";
  let personCondition = denuncianteTitle.toLowerCase();
  if (personCondition.includes("protagonistas")) {
    personCondition = "protagonista/acompañante o damnificado";
  }
  if (denuncianteTitle.includes("Víctima")) {
    personCondition = `de la ${personCondition}`;
  } else {
    personCondition = `del ${personCondition}`;
  }

  if (viewData.value.showPeoplesAlertas) {
    if (errors.value.includes("Se registraron denunciante y acusado iguales")) {
      return "Se registraron denunciante y acusado iguales";
    } else if (errors.value.includes("Se registraron denunciantes repetidos")) {
      return "Se registraron denunciantes repetidos";
    } else if (errors.value.includes("Falta DNI del denunciante y/o damnificado")) {
      return "Falta DNI del afectado";
    } else if (errors.value.includes("Falta teléfono del denunciante y/o damnificado")) {
      return "Falta teléfono del afectado";
    } else if (errors.value.includes("Falta apellido del denunciante y/o damnificado")) {
      return "Falta apellido del afectado";
    } else if (errors.value.includes("Falta nombre del denunciante y/o damnificado")) {
      return "Falta nombre del afectado";
    } else if (errors.value.includes("Falta estado civil del denunciante y/o damnificado")) {
      return "Falta estado civil del afectado";
    } else if (errors.value.includes("Falta fecha de nacimiento del denunciante y/o damnificado")) {
      return "Falta fecha de nacimiento del afectado";
    } else if (errors.value.includes("Falta domicilio del denunciante y/o damnificado")) {
      return "Falta domicilio del afectado";
    } else if (errors.value.includes("Falta DNI del damnificado")) {
      return "Falta número de documento del afectado";
    } else if (errors.value.includes("Falta apellido del damnificado")) {
      return "Falta apellido del afectado";
    } else if (errors.value.includes("Falta nombre del damnificado")) {
      return "Falta nombre del afectado";
    } else if (errors.value.includes("Falta estado civil del damnificado")) {
      return "Falta estado civil del afectado";
    } else if (errors.value.includes("Falta fecha de nacimiento del damnificado")) {
      return "Falta fecha de nacimiento del afectado";
    } else if (errors.value.includes("Falta teléfono del damnificado")) {
      return "Falta teléfono del afectado";
    } else if (errors.value.includes("Al menos 1 afectado tiene un email con formato incorrecto")) {
      return "Al menos 1 afectado tiene un email con formato incorrecto";
    } else if (
      errors.value.includes("Debe especificar al menos un Damnificado de tipo Orden Público")
    ) {
      return "Debe especificar al menos un Damnificado de tipo Orden Público";
    } else if (errors.value.includes("Email con formato incorrecto")) {
      return "Existe al menos un email con formato incorrecto";
    } else if (errors.value.includes("Falta domicilio del damnificado")) {
      return "Falta domicilio del afectado";
    } else if (errors.value.includes("Falta email del denunciante")) {
      return "Falta email del denunciante";
    }
  }

  return "ok";
};
/* eslint-enable no-else-return */

const warningAlerts = () => {
  if (
    warning.value.includes("Falta Email del afectado") &&
    !errors.value.includes("Falta email del denunciante")
  ) {
    return "Falta Email del afectado";
  }
  return "ok";
};

const inputSexo = () => {
  const sexoValue = dataSexo.value;
  if (!sexoValue || typeof sexoValue !== "string") return;

  const value = sexoList.value.filter(
    (item) => item.nombre.toLowerCase().search(sexoValue.toLowerCase()) >= 0
  );

  [sexo.value] = value;
};

const filterSexo = (event) => {
  filteredSexo.value = sexoList.value.filter(
    (item) => item.nombre.toLowerCase().search(event.query.toLowerCase()) >= 0
  );
};

const getPeople = async () => {
  if (dni.value < 1000000) {
    error.value = "El DNI debe tener al menos 7 dígitos";
    return;
  }

  if (dni.value >= 1000000000) {
    error.value = "El DNI no puede tener más de 9 dígitos";
    return;
  }

  try {
    isSearching.value = true;
    error.value = false;
    timer.value = false;
    await searchPeopleFromSipe();
    timer.value = true;
  } catch (e) {
    console.log("error", e);
  }
};

async function searchPeopleFromSipe() {
  let data = {};
  try {
    const sexoNombre = dataSexo.value?.nombre === "Masculino" ? "M" : "F";
    const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/data-persona?dni=${dni.value}&sexo=${sexoNombre}`;
    const result = await fetch(url, {
      credentials: "include",
    });

    data = await result.json();
  } catch (e) {
    console.error("err", e);
    people.value = {};
    error.value = "Datos incompletos o problema de conexión con SIPE.";
    isSearching.value = false;
    return;
  }

  if (data?.sipe?.resultadoWS?.exito === true) {
    const [address] = data.sipe.personaInfo.domicilios.domicilio;
    const datas = {
      nombre: data.sipe.personaInfo.nombre,
      apellido: data.sipe.personaInfo.apellido,
      documento: dni.value,
      domicilioSIPE: `${address.calle} ${address.numero} ${address.barrio} CP: ${address.cpostal} ${address.municipio}, ${address.provincia}, ${address.pais}`,
      fechaNacimiento: data.sipe.personaInfo.fechaNacimiento,
      sexo: dataSexo.value,
    };
    people.value = datas;
    emit("updateValue", people.value);
    isSearching.value = false;
  } else {
    people.value = {};
    error.value = "Persona no encontrada";
    isSearching.value = false;
  }
}

const onMouseleave = () => {
  if (deleteConfirmationInProgress.value !== true || modalVisble.value !== true) {
    showDeleteButton.value = false;
  }
};

const pasteInDeposition = (item) => {
  let paste =
    item.doc.domicilioSIPE !== undefined
      ? `${item?.doc?.condicion?.nombre} ${nombreYapellidos(item)} ${item.doc.domicilioSIPE}`
      : `${item?.doc?.condicion?.nombre} ${nombreYapellidos(item)}`;

  if (item.ordenPublico) {
    paste = `${
      item?.doc?.condicion?.nombre !== undefined
        ? `${item?.doc?.condicion?.nombre} Persona jurídica:`
        : "Persona jurídica:"
    } Cuil:${item.doc.cuit}, rubro:${item.doc.rubro}, telefono:${
      item.doc.telefonoJuridico
    }, tiene seguro:${item.doc.tieneSeguro ? "SI" : "NO"}, domicilio legal:${
      item.doc.domicilioJuridico
    }`;
  }
  emit("moveToDeposition", paste, "whistleblower");
};

const changeOrAddShowButton = (arrId) => {
  if (deleteConfirmationInProgress.value !== true || modalVisble.value !== true) {
    showDeleteButton.value = arrId;
  }
};

const colorTag = (value) => {
  switch (value) {
    case "Denunciante y Damnificado":
      return "success";
    case "Denunciante":
      return "warning";
    case "Damnificado":
      return "danger";
    case "Víctima":
      return "info";
    case "Fallecido":
      return "secondary";
    case "Protagonista":
      return "primary";
    case "Acompañante":
      return "warning";
    case "Peatón":
      return "help";
    default:
      return "";
  }
};

defineExpose({
  isSearching,
  people,
  dniPeople,
  error,
  dataSexo,
  filteredSexo,
  timer,
  showDeleteButton,
  emitNavigateEvent,
  ManageActions,
  nombreYapellidos,
  alertas,
  warningAlerts,
  inputSexo,
  filterSexo,
  getPeople,
  $_Peoples_sipeSearch: searchPeopleFromSipe,
  deleteConfirmation,
  onMouseleave,
  pasteInDeposition,
  changeOrAddShowButton,
  colorTag,
});
</script>

<script>
export default {
  name: "PeoplesCard",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  font-size: 1rem;
}
.address {
  font-size: 0.8rem;
  margin-left: 1px;
  margin-top: -15px;
}
.delete_action {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}
.title-icon {
  display: flex;
  align-items: center;
}
.borderShadow:focus {
  box-shadow: 0 0 0 0.2rem #89d4fe;
  outline: none;
}
.gender {
  margin-top: 0px;
  margin-bottom: 5px;
}
.search > input {
  margin-right: 10px;
}
p.title > span {
  font-weight: 600;
  color: var(--primary-color);
}
ul {
  list-style: none;
  padding: 0;
}
ul li {
  list-style: none;
  margin: 0 0 5px;
  padding: auto 0;
}
.mt-10 {
  margin-top: 10px;
}
.mr-8 {
  margin-right: 8px;
}
.spinner {
  display: none;
}
.passed {
  border-bottom: solid 2px #28a745;
  /* background-color: #28a745; */
}
.warningPeoples {
  border-bottom: solid 2px #ffc107;
}
.error {
  border: solid 2px #dc3545;
}
.paste-button {
  width: 25px;
}
.help {
  background: var(--help);
}
.secondary {
  background: var(--secondary);
}
.disabled {
  pointer-events: none;
  filter: brightness(0.9);
}
</style>
